/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import { Box, Button, Divider, Icon, Typography } from "@mui/material";
import {
  esquemaDeValidacionExperiencia,
  IExperienciaLaboralForm,
  valoresInicialesEsperienciaLaboral,
} from "./utils";
import ExperienciaItem from "./ItemExperienciaLaboral";
import {
  calcularMesesExperiencia,
  validarExperienciaMinima,
} from "src/utils/perfil";
import { PerfilesId } from "../../../utils/perfil";
import CustomDialog from "src/components/dialogo/CustomDialog";

export interface ExperienciaLaboralProps {
  setExperienciaLaboral: (values: any) => void;
  handleNext: () => void;
  handleBack: () => void;
  perfilSeleccionado: PerfilesId;
  experienciaLaboral: IExperienciaLaboralForm;
  onSubmit: (values: IExperienciaLaboralForm) => void;
  aspiranteId: string;
}

const ExperienciaLaboralForm = ({
  setExperienciaLaboral,
  handleNext,
  handleBack,
  perfilSeleccionado,
  experienciaLaboral,
  onSubmit,
  aspiranteId,
}: ExperienciaLaboralProps) => {
  const handleSubmit = (
    values: typeof valoresInicialesEsperienciaLaboral,
  ) => {};

  const [mostrarAdvertenciaPerfil, setMostrarAdvertenciaPerfil] =
    useState(false);
  const [mensajeAdvertenciaPerfil, setMensajeAdvertenciaPerfil] = useState("");

  return (
    <Formik
      initialValues={experienciaLaboral}
      validationSchema={esquemaDeValidacionExperiencia}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, validateForm, isValid, submitForm }) => (
        <Form>
          <FieldArray name="experienciasLaborales">
            {({ push, remove }) => (
              <Box>
                {values.experienciasLaborales.map((_, index) => (
                  <ExperienciaItem
                    key={index}
                    index={index}
                    remove={remove}
                    setFieldValue={setFieldValue}
                    values={values}
                    aspiranteId={aspiranteId}
                  />
                ))}
                <Button
                  variant="outlined"
                  onClick={() =>
                    push({
                      tipo: "",
                      nombreEmpresaInstitucion: "",
                      fechaInicio: "",
                      fechaFin: "",
                      nombreJefeInmediato: "",
                      telefonoJefeInmediato: "",
                      soporteId: "",
                    })
                  }
                >
                  Agregar experiencia
                </Button>
              </Box>
            )}
          </FieldArray>
          <Divider sx={{ marginY: 2 }} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
              gap: 1,
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                handleBack();
                setExperienciaLaboral(values);
              }}
              startIcon={<Icon>chevron_left</Icon>}
            >
              Atrás
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                validateForm();
                const validacionExperiencias = validarExperienciaMinima(
                  perfilSeleccionado,
                  calcularMesesExperiencia(values.experienciasLaborales),
                );
                if (!validacionExperiencias.cumple) {
                  setMostrarAdvertenciaPerfil(true);
                  setMensajeAdvertenciaPerfil(validacionExperiencias.mensaje);
                  return;
                }
                submitForm();
                if (isValid) {
                  handleNext();
                  setExperienciaLaboral(values);
                }
              }}
              endIcon={<Icon>chevron_right</Icon>}
            >
              Continuar
            </Button>
          </Box>
          <CustomDialog
            mostrar={mostrarAdvertenciaPerfil}
            onClose={() => {
              setMostrarAdvertenciaPerfil(false);
            }}
            contenido={
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {mensajeAdvertenciaPerfil}
              </Typography>
            }
            acciones={
              <Button
                onClick={() => {
                  setMostrarAdvertenciaPerfil(false);
                }}
              >
                Aceptar
              </Button>
            }
            titulo={
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                <Icon color="warning">warning</Icon> No cumple con los
                requisitos de experiencia mínima.
              </Typography>
            }
            tamanioMaximo="md"
            fullWidth
          />
        </Form>
      )}
    </Formik>
  );
};

export default ExperienciaLaboralForm;
